<template>
  
    <!-- <video-bg :sources="['static/videos/high.mp4']" img="static/videos/high.png">

    </video-bg> -->
</template>

<script>
  export default {
    name: 'Video',
    data() {
      return {
        video: 'static/videos/001.mp4',
        videoStyle: {

        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Video.vue